import React, { useState, useEffect } from "react";
import BackButton from "components/Button/BackButton";
import SaveButton from "components/Button/SaveButton";
import { useNavigate } from "react-router-dom";
import { FormTypeAdd, FormTypeEdit, ModalTypeConfirmation, ModalTypeFail, ModalTypeLoading, ModalTypeSuccess } from "utils/Constant";
import { useModal } from "components/modal/ModalContext";
import { useCallApi } from "api/apiHooks";
import { CheckResponse } from "utils/helpers";
import { FormCard, PagesTitle } from "components/Cards";

export default function CategoryForm(){
    let navigate = useNavigate()
    const { openModal, closeModal } = useModal()
    const { fetchUpdateCategory, fetchCategoryById, fetchCreateCategory } = useCallApi()
    
    let queryString = new URLSearchParams(window.location.search)
    let formType = queryString.get("formType")
    let categoryId = queryString.get("categoryId")

    const [categoryName, setCategoryName] = useState('')
    
    // Button Event
    const saveBtnClick = () => {
        if(validation()){
            openModal(ModalTypeConfirmation, {
                onConfirm: () => {
                    openModal(ModalTypeLoading)
    
                    if (formType === FormTypeAdd) {
                        fetchCreateCategory(categoryName).then((res) => {
                            if (CheckResponse(res)) {
                                openModal(ModalTypeSuccess, {
                                    onSuccess: () => {
                                        closeModal()
                                        navigate("/category") 
                                    }
                                })
                            } else {
                                openModal(ModalTypeFail, { message: res.message })
                            }
                        })
                    } else {
                        fetchUpdateCategory(categoryId, categoryName).then((res) => {
                            if (CheckResponse(res)) {
                                openModal(ModalTypeSuccess, {
                                    onSuccess: () => {
                                        closeModal()
                                        navigate("/category") 
                                    }
                                })
                            } else {
                                openModal(ModalTypeFail, { message: res.message })
                            }
                        })
                    }                    
                }
            })
        }
    }
    const backBtnClick = () => {
        navigate(-1)
    }
    
    // Function
    const validation = () => {
        if (categoryName === null) {
            openModal(ModalTypeFail, { message: 'Category Name is required!' })
            return false
        }

        return true
    }
    
    useEffect(() => {
        // If Form Type Edit then get data
        if (formType === FormTypeEdit) {
            openModal(ModalTypeLoading)

            fetchCategoryById(categoryId).then((res) => {
                if (CheckResponse(res)) {
                    let data = res.data

                    // Data
                    setCategoryName(data.categoryName)

                    closeModal()
                } else {
                    openModal(ModalTypeFail, { message: res.message })
                }
            })
        }
    }, [])

    return(
        <div className="flex p-3 min-h-full w-full">
            <div className="flex flex-col w-full justify-between gap-2 sm:bg-white sm:p-6 sm:rounded-xl sm:shadow-lg min-h-full">
                <div>
                    <PagesTitle title='Category Detail' />

                    <div className="mt-5 flex flex-col gap-3 ">
                        {/* Category Name */}
                        <FormCard title='Category Name'>
                            <input className="input" value={categoryName} onChange={(e) => { setCategoryName(e.target.value) }} maxLength={20} />
                        </FormCard>
                    </div>
                </div>            

                {/* Button */}
                <div className="mt-5 flex flex-wrap justify-end gap-2">
                    <SaveButton onClick={saveBtnClick} visible={true} />
                    <BackButton onClick={backBtnClick} />
                </div>
            </div>
        </div>
        
    )
}
